import React, { createContext, useState, useEffect } from 'react';

export const NewsContext = createContext();
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const NewsProvider = ({ children }) => {
  const [news, setNews] = useState(null);
  const [loadingNews, setLoadingNews] = useState(true);
  const [errorNews, setErrorNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/news`);
        if (!res.ok) throw new Error('Failed to fetch news');
        const data = await res.json();
        // console.log(data);
        // const fiftyRecords = Array.from({ length: 190 }, (_, i) => ({
        //   ...data[i % data.length], // repeat the item
        //   duplicate_id: i + 1, // add unique key for React (optional)
        // }));
        setNews(data);
      } catch (err) {
        setErrorNews(err.message);
      } finally {
        setLoadingNews(false);
      }
    };
    fetchNews();
  }, []);

  return (
    <NewsContext.Provider value={{ news, loadingNews, errorNews }}>{children}</NewsContext.Provider>
  );
};
